import React from 'react';
import Header from '../components/Header';
import ComplaintForm from '../components/ComplaintForm';

function ComplaintPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-6xl mx-auto p-4 md:p-6">
        <h2 className="text-2xl font-bold mb-1 text-text">Registrar relato</h2>
        <p className="text-gray-600 mb-6">Conte como foi o processo seletivo. Seja específico e honesto.</p>
        <ComplaintForm />
      </div>
    </div>
  );
}

export default ComplaintPage;
